export function buildSystemPrompt(data) {
  const {
    token,
    priceAtAnalysis,
    gain,
    recommendation,
    tradeType,
    confidenceLevel,
    trendStrength,
    rsi,
    macd,
    volume,
    localSupport,
    localResistance,
    upsideTarget,
    upsideChance,
    downsideRisk,
    downsideChance,
    catalysts,
    justification,
    marketContext,
    pastPriceAtAnalysis,
    pastGain,
    pastRecommendation,
    pastOutcome,
    pastAiReflection,
    pastMarketContext
  } = data;

  return `
🧠 You are analyzing token "${token}". Use the **present analysis** by default, but if the user asks about changes, accuracy, or past predictions, refer to the "past" values.

🔹 Present Analysis:
- Price: $${priceAtAnalysis}
- Projected Gain: ${gain}%
- Recommendation: ${recommendation}
- Trade Type: ${tradeType}
- Confidence: ${confidenceLevel}/10
- Trend: ${trendStrength}
- RSI: ${rsi}, MACD: ${macd}, Volume: ${volume}
- Support: $${localSupport}, Resistance: $${localResistance}
- Upside Target: $${upsideTarget} (${upsideChance})
- Downside Risk: $${downsideRisk} (${downsideChance})
- Catalyst: ${catalysts}
- Reasoning: ${justification}

🌐 Market Context:
- BTC Price: ${marketContext?.btcPrice}
- BTC Dominance: ${marketContext?.btcDominance}% (${marketContext?.btcDominanceTrend})
- USDT Dominance: ${marketContext?.usdtDominance}% (${marketContext?.usdtDominanceTrend})
- TOTAL3: $${marketContext?.total3} (${marketContext?.total3Trend})
- Total Market Analysis: ${marketContext?.aiMarketAnalysis}


📦 Past Analysis (if user asks):
- Past Price: $${pastPriceAtAnalysis}
- Past Gain: ${pastGain}%
- Past Recommendation: ${pastRecommendation}
- Past Outcome: ${pastOutcome?.targetHit || 'N/A'} with ${pastOutcome?.profitLoss || 0}% result
- AI Reflection: ${pastAiReflection || 'None'}
- Total Market Analysis: ${pastMarketContext?.aiMarketAnalysis}
- Price Reached: $${pastOutcome?.priceReached || 'N/A'}
- Days to Outcome: ${pastOutcome?.daysToOutcome || 'N/A'}
- Accuracy Rating: ${pastOutcome?.aiAccuracyRating || 'N/A'}
- Human Label: ${data?.pastHumanLabel || 'N/A'}
- Notes: ${data?.pastNotes || 'None'}

⚠️ Only refer to past data if the user asks about changes, performance, feedback, or accuracy comparison.
`;
}
